import { withInstall } from '@zoryn/utils'
import TreeV2 from './src/tree.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTreeV2: SFCWithInstall<typeof TreeV2> = withInstall(TreeV2)
export default ZTreeV2

export type { TreeV2Instance } from './src/instance'
